import { render, staticRenderFns } from "./TutoriaIngresarNota.vue?vue&type=template&id=031c3adb&"
import script from "./TutoriaIngresarNota.vue?vue&type=script&lang=js&"
export * from "./TutoriaIngresarNota.vue?vue&type=script&lang=js&"
import style0 from "./TutoriaIngresarNota.vue?vue&type=style&index=0&id=031c3adb&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports